
import React, { useEffect, useState } from 'react'
import { Card, Col, Modal, Row, Tabs } from 'antd'
import { Button } from 'antd'
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { FaArrowRight, FaMinus } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import FlightRoundTripFareCard from './FlightRoundTripFareCard';
import { fetchFlightOffers } from '../../../redux/flight/flightOffersSlice';

function DomasticSelection({ departureData, arrivalDataReturn, filteredReturnFlights, memoizedFlightsInternational }) {

    let navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [roundTripModalData, setRoundTripModalData] = useState(null)
    const [roundTripModalReturnData, setRoundTripModalReturnData] = useState(null)
    const [tabKey, setTabKey] = useState('Departure');
    const flightsData = memoizedFlightsInternational;
    
    const currentDepartureData = departureData || flightsData?.flights?.[0];
    const currentArrivalData = arrivalDataReturn || flightsData?.returnFlights?.[0];

    const fetchFlightDetails = () => {
        if (currentDepartureData && currentArrivalData) {
            setRoundTripModalData(currentDepartureData);
            setRoundTripModalReturnData(currentArrivalData);
            setIsModalOpen(true);
        } else {
            console.error("Cannot open modal: missing flight data");
        }
    };

    const handleTabChange = (key) => {
        setTabKey(key);
    };

    const [selectedValue, setSelectedValue] = useState(0);
    const [selectedData, setSelectedData] = useState(null);
    const [selectedCard, setSelectedCard] = useState(null);

    const [selectedValueReturn, setSelectedValueReturn] = useState(0);
    const [selectedCardReturn, setSelectedCardReturn] = useState(null);
    const [selectedDataReturn, setSelectedDataReturn] = useState(null);

    useEffect(() => {
        if (roundTripModalData?.priceOptions?.length > 0) {
            setSelectedCard(roundTripModalData.priceOptions[0]?.id);
            setSelectedValue(0);
            setSelectedData(roundTripModalData.priceOptions[0]);
        }
    }, [roundTripModalData]);

    useEffect(() => {
        if (roundTripModalReturnData?.priceOptions?.length > 0) {
            setSelectedCardReturn(roundTripModalReturnData.priceOptions[0]?.id);
            setSelectedValueReturn(0);
            setSelectedDataReturn(roundTripModalReturnData.priceOptions[0]);
        }
    }, [roundTripModalReturnData]);

    const handleChange = (index, id, data) => {
        setSelectedValue(index);
        setSelectedCard(id);
        setSelectedData(data);
        setTabKey('Return');
    };

    const handleChangeReturn = (index, id, data) => {
        setSelectedValueReturn(index);
        setSelectedCardReturn(id);
        setSelectedDataReturn(data);
    };

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchFlightOffers());
    }, [dispatch]);

    const { offers, loading, error } = useSelector((state) => state.flightOffers);
    const selectedCards = { selectedCard, selectedCardReturn };

    const onwardFare = selectedData?.totalFare || roundTripModalData?.priceOptions?.[0]?.totalFare || 0;
    const returnFare = selectedDataReturn?.totalFare || roundTripModalReturnData?.priceOptions?.[0]?.totalFare || 0;

    const totalFare = onwardFare + returnFare;

    const [totalAmount, setTotalAmount] = useState(0);

    useEffect(() => {
        if (currentDepartureData && currentArrivalData) {
            const departureFare = currentDepartureData?.priceOptions?.[0]?.totalFare || 0;
            const returnFare = currentArrivalData?.priceOptions?.[0]?.totalFare || 0;
            const total = departureFare + returnFare;
            setTotalAmount(total);
        }
    }, [currentDepartureData, currentArrivalData]);

    const [filteredOffers, setFilteredOffers] = useState([]);
    const [discountedTotal, setDiscountedTotal] = useState(totalAmount);

    useEffect(() => {
        const applicableOffers = offers.filter(
            (offer) =>
                parseFloat(offer.min_order_value) <= totalAmount &&
                parseFloat(offer.max_order_value) >= totalAmount
        );

        setFilteredOffers(applicableOffers);
        let finalAmount = totalAmount;

        if (applicableOffers.length > 0) {
            const bestOffer = applicableOffers[0];
            if (bestOffer.discountType === "AMOUNT") {
                finalAmount -= parseFloat(bestOffer.discount);
            } else if (bestOffer.discountType === "PERCENTAGE") {
                finalAmount -= (finalAmount * parseFloat(bestOffer.discount)) / 100;
            }
        }

        setDiscountedTotal(finalAmount);
    }, [totalAmount]);

    const getVendorType = () => {
        return currentDepartureData?.vendor || 'TBO';
    };

    const vendorType = getVendorType();

    const getFlightDetails = () => {
        return {
            traceId: currentDepartureData?.traceId,
            departureFlightId: currentDepartureData?.flightId,
            returnFlightId: currentArrivalData?.flightId
        };
    };

    const { traceId, departureFlightId, returnFlightId } = getFlightDetails();

    return (
        <>
            <Card className="card flights-list-item bg-white rounded-3 p-md-0 mb-md-1 DomesticReturnSelection">
                <Row className='d-none'>
                    <Col xs={12} md={12} className='border-end'>
                        <div className='mobile_screen_return'>
                            <div className='d-flex align-items-center gap-2 mb-1 justify-content-center'>
                                <small className="text-muted text-sm fw-bold">{currentDepartureData?.origin}</small>
                                <FaArrowRight />
                                <small className="text-muted text-sm fw-bold">{currentDepartureData?.destination}</small>
                            </div>
                            <div className='d-flex align-items-center justify-content-center gap-2'>
                                <img
                                    className='img-collection result-flight'
                                    src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${currentDepartureData?.flightCode}.gif`}
                                    alt="logo"
                                    onError={(e) => {
                                        e.target.src = 'https://via.placeholder.com/50';
                                    }}
                                />
                                <div className='d-flex align-items-center gap-1'>
                                    <div className="text-dark fw-bold">{moment(currentDepartureData?.departureTime).format('HH:mm')}</div>
                                    <small className='lh-sm'><FaMinus /></small>
                                    <div className="text-dark fw-bold">{moment(currentDepartureData?.arrivalTime).format('HH:mm')}</div>
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col xs={12} md={12}>
                        <div className='mobile_screen_return'>
                            <div className='d-flex align-items-center gap-2 mb-1 justify-content-center'>
                                <small className="text-muted text-sm fw-bold">{currentArrivalData?.origin}</small>
                                <FaArrowRight />
                                <small className="text-muted text-sm fw-bold">{currentArrivalData?.destination}</small>
                            </div>
                            <div className='d-flex align-items-center justify-content-center gap-2'>
                                <img
                                    className='img-collection result-flight'
                                    src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${currentArrivalData?.flightCode}.gif`}
                                    alt="logo"
                                    onError={(e) => {
                                        e.target.src = 'https://via.placeholder.com/50';
                                    }}
                                />
                                <div className='d-flex align-items-center gap-1'>
                                    <div className="text-dark fw-bold">{moment(currentArrivalData?.departureTime).format('HH:mm')}</div>
                                    <small className='lh-sm'><FaMinus /></small>
                                    <div className="text-dark fw-bold">{moment(currentArrivalData?.arrivalTime).format('HH:mm')}</div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row gutter={20} className="gy-4 align-items-center justify-content-between">
                    <Col xs={12} xl={10} className='border-end d-none d-md-block'>
                        <Row gutter={16} className="gx-lg-5 gx-3 gy-4 align-items-center flight-details-cntr">
                            <Col xs={4} md={6}>
                                <div className="fl-pic">
                                    <img
                                        className='img-collection result-flight'
                                        src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${currentDepartureData?.flightCode}.gif`}
                                        alt="logo"
                                        onError={(e) => {
                                            e.target.src = 'https://via.placeholder.com/50';
                                        }}
                                    />
                                    <div className='d-none d-md-block lh-sm'>
                                        <small className="text-dark fw-medium lh-sm d-block">{currentDepartureData?.airline}</small>
                                        <small className="text-sm text-muted d-none">{currentDepartureData?.flightNumber}</small>
                                    </div>
                                </div>
                            </Col>

                            <Col xs={20} md={18}>
                                <small className="text-muted fw-bold mb-1">{moment(currentDepartureData?.departureTime).format('DD MMM YYYY')}</small>
                                <Row gutter={16} className="row gx-3 align-items-center">
                                    <Col xs={12} md={7} className='lh-sm'>
                                        <div className="text-dark fs-6 fw-bold">{moment(currentDepartureData?.departureTime).format('HH:mm')}</div>
                                        <small className="text-muted text-sm fw-bold">{currentDepartureData?.origin}</small>
                                    </Col>

                                    <Col md={8} className="text-center lh-sm">
                                        <small>
                                            {moment.duration(currentDepartureData?.duration, 'minutes').hours() + 'H ' + moment.duration(currentDepartureData?.duration, 'minutes').minutes() + 'M'}
                                            <br />
                                            {(() => {
                                                const stops = currentDepartureData?.stops || 0;
                                                return stops === 0
                                                    ? 'Non-Stop'
                                                    : `${stops} stop${stops > 1 ? 's' : ''}`;
                                            })()}
                                        </small>
                                    </Col>

                                    <Col xs={12} md={7} className='lh-sm text-md-end'>
                                        <div className="text-dark fs-6 fw-bold">{moment(currentDepartureData?.arrivalTime).format('HH:mm')}</div>
                                        <small className="text-muted text-sm fw-bold">{currentDepartureData?.destination}</small>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    
                    <Col xs={12} xl={10} className='d-none d-md-block'>
                        <Row gutter={16} className="gx-lg-5 gx-3 gy-4 align-items-center flight-details-cntr">
                            <Col md={1}></Col>
                            <Col xs={5} md={5}>
                                <div className="fl-pic">
                                    <img
                                        className='img-collection result-flight'
                                        src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${currentArrivalData?.flightCode}.gif`}
                                        alt="logo"
                                        onError={(e) => {
                                            e.target.src = 'https://via.placeholder.com/50';
                                        }}
                                    />
                                    <div className='d-none d-md-block lh-sm'>
                                        <small className="text-dark fw-medium lh-sm d-block">{currentArrivalData?.airline}</small>
                                        <small className="text-sm text-muted d-none">{currentArrivalData?.flightNumber}</small>
                                    </div>
                                </div>
                            </Col>

                            <Col xs={18} md={17}>
                                <small className="text-muted fw-bold mb-1">{moment(currentArrivalData?.departureTime).format('DD MMM YYYY')}</small>
                                <Row gutter={16} className="row gx-3 align-items-center">
                                    <Col xs={12} md={7} className='lh-sm'>
                                        <div className="text-dark fs-6 fw-bold">{moment(currentArrivalData?.departureTime).format('HH:mm')}</div>
                                        <small className="text-muted text-sm fw-bold">{currentArrivalData?.origin}</small>
                                    </Col>

                                    <Col md={8} className="text-center lh-sm">
                                        <small>
                                            {moment.duration(currentArrivalData?.duration, 'minutes').hours() + 'H ' + moment.duration(currentArrivalData?.duration, 'minutes').minutes() + 'M'}
                                            <br />
                                            {(() => {
                                                const stops = currentArrivalData?.stops || 0;
                                                return stops === 0
                                                    ? 'Non-Stop'
                                                    : `${stops} stop${stops > 1 ? 's' : ''}`;
                                            })()}
                                        </small>
                                    </Col>

                                    <Col xs={12} md={7} className='lh-sm text-md-end'>
                                        <div className="text-dark fs-6 fw-bold">{moment(currentArrivalData?.arrivalTime).format('HH:mm')}</div>
                                        <small className="text-muted text-sm fw-bold">{currentArrivalData?.destination}</small>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>

                    <Col xl={4} xs={24} className='mobile_pricing px-4 px-md-2'
                        onClick={fetchFlightDetails}>
                        <div className="text-start text-md-end lh-sm">
                            <span className='text-sm text-white lh-sm d-md-none'>
                                <small>{currentDepartureData?.flightCode} ₹{(currentDepartureData?.priceOptions?.[0]?.totalFare || 0).toLocaleString()}</small>
                                <small className='mx-1'>|</small>
                                <small>{currentArrivalData?.flightCode} ₹{(currentArrivalData?.priceOptions?.[0]?.totalFare || 0).toLocaleString()}</small>
                            </span>
                            <div className="text-dark fs-4 fw-bold lh-sm">
                                ₹{((currentDepartureData?.priceOptions?.[0]?.totalFare || 0) + (currentArrivalData?.priceOptions?.[0]?.totalFare || 0)).toLocaleString()}
                            </div>
                        </div>

                        <Button
                            type="primary"
                            className='float-end d-flex align-items-center fw-bold'
                            aria-label="Book now"
                        >
                            Book Now
                        </Button>
                    </Col>

                    {totalAmount - discountedTotal > 0 && filteredOffers.length > 0 &&
                        <Col xs={24} className='text-center mt-1'>
                            <span className=' px-4 text-center text-sm text-primary fw-bold rounded d-inline-flex align-items-center' style={{ padding: '3px 0' }}>
                                <svg style={{ fill: 'var(--primary-color)' }} width="1.2em" height="1.2em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="m20.749 12 1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1h-2.199l-1.103-1.909a1.008 1.008 0 0 0-.607-.466.993.993 0 0 0-.759.1L12 3.251l-1.91-1.105a1 1 0 0 0-1.366.366L7.62 4.422H5.421a1 1 0 0 0-1 1v2.199l-1.91 1.104a.998.998 0 0 0-.365 1.367L3.25 12l-1.104 1.908a1.004 1.004 0 0 0 .364 1.367l1.91 1.104v2.199a1 1 0 0 0 1 1h2.2l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135l1.908-1.104 1.91 1.104a1.001 1.001 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1v-2.199l1.91-1.104a1 1 0 0 0 .365-1.367L20.749 12zM9.499 6.99a1.5 1.5 0 1 1-.001 3.001 1.5 1.5 0 0 1 .001-3.001zm.3 9.6-1.6-1.199 6-8 1.6 1.199-6 8zm4.7 .4a1.5 1.5 0 1 1 .001-3.001 1.5 1.5 0 0 1-.001 3.001z"></path>
                                </svg>
                                {`Get ₹${Math.round(totalAmount - discountedTotal)} discount using ${filteredOffers?.[0]?.code || 'OFFER'}`}
                            </span>
                        </Col>
                    }
                </Row>
            </Card>

            <Modal
                className='FlightFareSelection p-0'
                open={isModalOpen}
                footer={null}
                onCancel={() => setIsModalOpen(false)}
                centered
                width={1000}
                destroyOnClose={true}
            >
                <h3 className='text-center mt-4'>Flight Details and Fare Options available for you!</h3>
                <Tabs
                    className="fare-tabs"
                    activeKey={tabKey}
                    onChange={handleTabChange}
                    items={[
                        {
                            label: (
                                <>
                                    Departure: {roundTripModalData?.origin} → {roundTripModalData?.destination}
                                </>
                            ),
                            key: 'Departure',
                            children: (
                                <div className="container mt-4" style={{ maxHeight: "350px", overflow: "auto" }}>
                                    <Row gutter={12}>
                                        {roundTripModalData?.priceOptions?.map((data, index) => (
                                            <Col key={data.id} md={8} className='mb-3'>
                                                <FlightRoundTripFareCard
                                                    data={data}
                                                    selectedValue={selectedValue === index}
                                                    selectedCard={selectedCard}
                                                    onChange={() => handleChange(index, data.id, data)}
                                                />
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            ),
                        },
                        {
                            label: (
                                <>
                                    Return: {roundTripModalReturnData?.origin} → {roundTripModalReturnData?.destination}
                                </>
                            ),
                            key: 'Return',
                            children: (
                                <div className="container mt-4" style={{ maxHeight: "350px", overflow: "auto" }}>
                                    <Row gutter={12}>
                                        {roundTripModalReturnData?.priceOptions?.map((data, index) => (
                                            <Col key={data.id} md={8} className='mb-3'>
                                                <FlightRoundTripFareCard
                                                    data={data}
                                                    selectedValue={selectedValueReturn === index}
                                                    selectedCard={selectedCardReturn}
                                                    onChange={() => handleChangeReturn(index, data.id, data)}
                                                />
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            ),
                        },
                    ]}
                />

                <div className='Fare_popup_bottom d-flex justify-content-between shadow p-3'>
                    <h4>Total Round Trip Base Fare</h4>
                    <div className='d-flex align-items-center gap-3'>
                        <h3>₹{totalFare?.toLocaleString()}</h3>

                        {(vendorType === "TripJack") && (
                            <Button
                                onClick={() => {
                                    navigate("/flight-review", {
                                        state: {
                                            selectedCards: selectedCard,
                                            selectedCardReturn: selectedCardReturn,
                                            vendorType: vendorType,
                                            departureData: roundTripModalData,
                                            returnData: roundTripModalReturnData
                                        }
                                    });
                                    sessionStorage.setItem("comeFromReview", "true");
                                }}
                                type="primary"
                                className='float-end d-flex align-items-center fw-bold'
                                aria-label="Proceed"
                            >
                                Proceed
                            </Button>
                        )}

                        {(vendorType === "TBO") &&
                            <Button
                                onClick={() => {
                                    navigate("/flight-review", {
                                        state: {
                                            traceId: traceId,
                                            selectedCards: departureFlightId,
                                            selectedCardReturn: returnFlightId,
                                            vendorType: vendorType,
                                            departureData: roundTripModalData,
                                            returnData: roundTripModalReturnData
                                        },
                                    });
                                    sessionStorage.setItem("comeFromReview", "true");
                                }}
                                type="primary"
                                className='float-end d-flex align-items-center fw-bold'
                                aria-label="Proceed"
                            >
                                Proceed
                            </Button>
                        }

                        {(vendorType !== "TripJack" && vendorType !== "TBO") && (
                            <Button
                                type="primary"
                                className='float-end d-flex align-items-center fw-bold'
                                disabled
                                aria-label="Proceed"
                            >
                                Vendor Not Supported
                            </Button>
                        )}
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default DomasticSelection